export default "__VITE_ASSET__8db3097e__"